import React from "react";

const UpdateConfirmSubmitModal = ({ isOpen, onConfirm, onCancel }) => {
  return (
    <div className={`modal ${isOpen ? "is-active" : ""}`}>
      <div className="modal-background" onClick={onCancel}></div>

      <div className="modal-card">
        <section className="modal-card-body">
          <p>
            You are about to submit original marks. You will not be able to edit
            these after submitting. Are you sure you want to proceed?
          </p>
        </section>

        <footer className="modal-card-foot">
          <button className="button is-success" onClick={onConfirm}>
            Yes
          </button>
          <button className="button" onClick={onCancel}>
            No
          </button>
        </footer>
      </div>
    </div>
  );
};

export default UpdateConfirmSubmitModal;
